<template>
  <div id="app" :style="`min-width:${checkIsMobile() ? 'auto' : '1600px'};`">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不会被缓存的视图组件 -->
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      logo: require('@/assets/logo.png'), //icon路径
      // 这里可以放置一些全局变量
      scale: null,
      scaleCopy: null,
    }
  },
  created() {
    // 这里可以执行一些初始化操作
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = this.logo // icon地址
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  mounted() {
    // this.setScale() // 初始时立即执行一次，
    // 监听页面缩放变化
    // window.addEventListener('resize', this.setScale)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.setScale)
  },
  methods: {
    checkIsMobile() {
      const ua = navigator.userAgent.toLowerCase()
      const isMobile =
        /phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian/i.test(
          ua
        )
      this.isMobile = isMobile
      return isMobile
    },
    setScale() {
      // 获取当前缩放比例
      console.log(window.devicePixelRatio, 'window.devicePixelRatio')
      let scale = 100
      if (window.devicePixelRatio) {
        scale = Number((window.devicePixelRatio * 100).toFixed(2))
      }
      if (scale !== 100) {
        if (this.checkIsMobile()) {
          return
        }
        console.log(this.$router, 'this.$router')
        console.log(this.$route, 'this.$route')

        let str = `<span style="color:red;font-size:20px"> 当前页面缩放比例为${scale}%,页面布局可能会错位，请尽量保持100%缩放。</span><br/><span style="color:#000;font-size:16px">可以Ctrl键+鼠标滚轮或Ctrl键+加号或减号来缩放页面，或者电脑显示设置缩放。</span>`
        this.$notify({
          title: '注意',
          dangerouslyUseHTMLString: true,
          message: str,
          duration: 2000,
        })
        // this.$alert(str, '注意!', {
        //   confirmButtonText: '确定',
        //   dangerouslyUseHTMLString: true,
        //   widht: 500,
        //   callback: () => {},
        // })
      }
    },
  },
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}
.icon,
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
i {
  font-style: normal;
}
#app {
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}
.color {
  color: #ccc;
}

.borderRight {
  border-right: 1px solid #cdd;
}

.borderLeft {
  border-left: 1px solid #cdd;
}

.borderTop {
  border-top: 1px solid #cdd;
}

.borderBottom {
  border-bottom: 1px solid #cdd;
}

.flexb {
  display: flex;
  justify-content: space-between;
}

.flexa {
  display: flex;
  justify-content: space-around;
}

.flexend {
  display: flex;
  justify-content: flex-end;
}

.flexs {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.flexCol {
  display: flex;
  flex-direction: column;
}

.jbetween {
  justify-content: space-between;
}

.acenter {
  align-items: center;
}

.text-center {
  text-align: center;
}

.bold {
  font-weight: bold;
}

.text-right {
  text-align: right;
}

.paddingRight10 {
  padding-right: 10px;
}

.paddingLeft10 {
  padding-left: 10px;
}

.paddingTop5 {
  padding-top: 5px;
}

.paddingLeft5 {
  padding-left: 5px;
}

.paddingRight5 {
  padding-right: 5px;
}

.border {
  border: 1px solid #ccc;
}

.height30 {
  line-height: 36px;
}

.flex2 {
  flex: 2;
}

.flex3 {
  flex: 3;
}

.flex4 {
  flex: 4;
}

.flex5 {
  flex: 5;
}

.flex6 {
  flex: 6;
}

.flex7 {
  flex: 7;
}

.flex8 {
  flex: 8;
}

.font30 {
  font-size: 30px;
}

.font20 {
  font-size: 20px;
}

.font13 {
  font-size: 13px;
}

.font14 {
  font-size: 14px;
}

.font15 {
  font-size: 15px;
}

.font16 {
  font-size: 16px;
}

.font17 {
  font-size: 17px;
}

.mt10 {
  margin-top: 10px;
}

.fcenter {
  display: flex;
  justify-content: center;
}

.flexAcneter {
  display: flex;
  align-items: center;
}

::v-deep.el-button {
  outline: none;
  border: none;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-select {
  width: 100%;
}

button:focus {
  outline: none;
}

.el-button:focus {
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.h5-confirm-class {
  width: 70vw !important;
}

.dateime {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}

.cascader-popper {
  z-index: 9000 !important;
}
.el-textarea__inner {
  font-family: Arial, Helvetica, sans-serif !important;
}
.el-input--small .el-input__inner {
  font-family: Arial, Helvetica, sans-serif !important;
}
.ellipsis {
  overflow: hidden; //超出隐藏

  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; //内容限制的行数
}
.ellipsis2 {
  overflow: hidden; //超出隐藏

  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; //内容限制的行数
}
.ellipsis3 {
  overflow: hidden; //超出隐藏

  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3; //内容限制的行数
}
.el-tabs__item {
  box-shadow: none !important;
  line-height: 36px !important;
  height: 36px !important;
}
.is-disabled {
  .el-textarea__inner {
    color: #606266 !important;
  }
  .el-input__inner {
    color: #606266 !important;
  }
}
.wh100 {
  width: 100%;
  height: 100%;
}
.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.df {
  display: flex;
}
.aic {
  align-items: center;
}
.juc {
  justify-content: center;
}
.jur {
  justify-content: right;
}
.jub {
  justify-content: space-between;
}
.cup {
  cursor: pointer;
}
.tac {
  text-align: center;
}
.tal {
  text-align: left;
}
.tar {
  text-align: right;
}
.el-table th.el-table__cell > .cell {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}
.el-pagination__total {
  font-weight: 700 !important;
  font-size: 18px !important;
}
.hint-text {
  font-size: 12px;
  color: #686868;
  margin-left: 10px;
}
.search-top {
  height: 30px;
  margin-bottom: 3px;
  margin-top: 3px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-between;
}
.el-upload-list__item.is-success.focusing .el-icon-close-tip {
  display: none !important;
}
.table-popper {
  width: 300px !important;
  background: rgba($color: #000000, $alpha: 0.7) !important;
  color: #fff !important;
  font-size: 14px !important;
  .el-popover__title {
    color: #fff !important;
    font-size: 14px !important;
  }

  .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.7) !important;
  }
}
</style>
